
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function DemoFooter() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <footer ref={ref} className="bg-slate-950 text-white relative overflow-hidden">
      <div className="h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-16 relative">
        <div
          className={`flex flex-col md:flex-row items-center justify-between gap-8 mb-10 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/d1374e619b7c88bb7ec9c29306d6d801.jpg" 
              alt="MtaPlannerPro Elite Logo" 
              className="w-12 h-12 object-contain"
            />
            <span className="text-white font-bold text-xl">MtaPlannerPro</span>
          </Link>

          <div className="flex items-center gap-8">
            <Link to="/" className="text-white/60 hover:text-white transition-colors cursor-pointer text-sm">
              Home
            </Link>
            <Link to="/invoice" className="text-white/60 hover:text-white transition-colors cursor-pointer text-sm">
              Quote Generator
            </Link>
            <Link to="/demo" className="text-amber-400 cursor-pointer text-sm font-medium">
              Book Demo
            </Link>
            <Link to="/resources" className="text-white/60 hover:text-white transition-colors cursor-pointer text-sm">
              Resources
            </Link>
          </div>

          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-twitter-x-line', href: 'https://twitter.com' },
              { icon: 'ri-linkedin-fill', href: 'https://linkedin.com' },
              { icon: 'ri-youtube-fill', href: 'https://youtube.com' },
            ].map((s, i) => (
              <a
                key={i}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 hover:border-amber-500/30 transition-all cursor-pointer"
              >
                <i className={`${s.icon} text-sm`} />
              </a>
            ))}
          </div>
        </div>

        <div
          className={`border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="text-white/40 text-xs">© 2025 MtaPlannerPro. All rights reserved.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer"
          >
            Web Design by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
